import { MatchCollection } from '../models/match-collection.model';
import { Match } from '../models/match.model';
import { Round } from '../models/round.model';
import { StackQueue } from '../models/stackqueue.model';
import { Team } from '../models/team.model';
import { WinnerOf } from '../models/winner-of.model';
import { sortMatchesBySeeding } from './sort-matches-by-seeding';

export const generateInitialMatches = (
  teamsTotal: number,
  capacityRoundSlots: number,
  capacityTeamsTotal: number,
  playInTeamsTotal: number
) => {
  const playInTeams = new StackQueue<Team | WinnerOf>();
  const capacityTeams = new StackQueue<Team | WinnerOf>();

  // Iterate through seeds to see which teams are in
  // capacity round and which are in play-in round
  for (let seed = 1; seed <= teamsTotal; seed++) {
    const list = seed <= capacityTeamsTotal ? capacityTeams : playInTeams;
    list.push(<Team>{ id: `seed-${seed.toString()}`, seed });
  }

  // Play-in round
  let currentMatchId = 0;
  const playInMatches = new MatchCollection();
  for (let m = 1; m <= playInTeamsTotal / 2; m++) {
    const match = <Match>{
      id: ++currentMatchId,
      slot1: playInTeams.popFirst(),
      slot2: playInTeams.pop(),
    };

    playInMatches.push(match);
    capacityTeams.push(new WinnerOf(match));
  }

  // Capacity round
  const capacityMatches = new MatchCollection();

  for (let m = 1; m <= capacityRoundSlots / 2; m++) {
    const slots = {
      slot1: capacityTeams.popFirst(),
      slot2: capacityTeams.pop(),
    };

    capacityMatches.push(<Match>{
      id: ++currentMatchId,
      ...slots,
    });
  }

  const sorted = sortMatchesBySeeding(
    capacityRoundSlots,
    playInMatches,
    capacityMatches
  );

  const playInRound = <Round>{
    alias: 'playins',
    matches: sorted.playInMatches,
  };
  const capacityRound = <Round>{
    alias: 'capacity',
    matches: sorted.capacityMatches,
  };

  return { playInRound, capacityRound };
};
